import {
  AddValidationsFormControlDependsOnSchema,
  DisableFormControlDependsOnSchema,
  HideFormControlDependsOnSchema,
  IsRequiredFormControlDependsOnSchema,
  SetFocusFormControlDependsOnSchema,
  SetValueFormControlDependsOnSchema,
  FormControlDependsOnSchema,
  FormControlDependsOnThenEnum
} from "../Schema/DependsOn";

export function isAddValidationsFormControlDependsOnSchema(
  schema: FormControlDependsOnSchema
): schema is AddValidationsFormControlDependsOnSchema {
  return schema.then === FormControlDependsOnThenEnum.AddValidations;
}

export function isDisableFormControlDependsOnSchema(
  schema: FormControlDependsOnSchema
): schema is DisableFormControlDependsOnSchema {
  return schema.then === FormControlDependsOnThenEnum.Disable;
}

export function isHideFormControlDependsOnSchema(
  schema: FormControlDependsOnSchema
): schema is HideFormControlDependsOnSchema {
  return schema.then === FormControlDependsOnThenEnum.Hide;
}

export function isRequiredFormControlDependsOnSchema(
  schema: FormControlDependsOnSchema
): schema is IsRequiredFormControlDependsOnSchema {
  return schema.then === FormControlDependsOnThenEnum.IsRequired;
}

export function isSetFocusFormControlDependsOnSchema(
  schema: FormControlDependsOnSchema
): schema is SetFocusFormControlDependsOnSchema {
  return schema.then === FormControlDependsOnThenEnum.SetFocus;
}

export function isSetValueFormControlDependsOnSchema(
  schema: FormControlDependsOnSchema
): schema is SetValueFormControlDependsOnSchema {
  return schema.then === FormControlDependsOnThenEnum.SetValue;
}
